import { putApiV1UserUserIdPreference } from '@/open-api/user/user';

import type { Theme } from '@/types/theme';

const themeNumberMap = { light: 0, dark: 1, system: 2 } as const;

/**
 * Saves the signed-in user's theme choice (0 = light, 1 = dark, 2 = system).
 */
export const setThemePreference = async (
  theme: Theme,
  userId: number | undefined
) => {
  if (!(userId && theme)) {
    return;
  }

  await putApiV1UserUserIdPreference(userId, {
    themePreference: themeNumberMap[theme],
  });
};
